// extracted by mini-css-extract-plugin
export default {"wrapper":"PhasesForm_wrapper__KAVIQ","container":"PhasesForm_container__BDkbz","icons":"PhasesForm_icons__0SQt9","drop-down-icon":"PhasesForm_drop-down-icon__dQdi7"};